import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import GuidedMove from 'components/Sales/Smart/MoveMerge/GuidedMove2';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartMove(): JSX.Element {
  return (
    <ContentLayout titleKey="titles.guidedMove" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}>
      <GuidedMove />
    </ContentLayout>
  );
}
